import { ApplicationName, ApplicationVersion } from '../constants';
import { CONFIG } from './config';

declare global {
    interface Window {
        __LANDR_DEVTOOLS_HOOKS__: {
            emit: (name: string, payload: any) => void;
            on: (name: string, callback: Function) => void;
        };
    }
}

const areDevToolsActive = () =>
    !!(window && window.document && window.__LANDR_DEVTOOLS_HOOKS__);

/**
 * Send an event to LANDR devtools with the initial application details
 */
export function setupLandrDevTools() {
    if (areDevToolsActive()) {
        window.__LANDR_DEVTOOLS_HOOKS__.emit('set-state', {
            name: ApplicationName,
            version: ApplicationVersion,
            config: CONFIG,
        });
    }
}

// TODO: add a component for Feature Flag connection with devtools
